var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PKPEthersWallet } from '@lit-protocol/pkp-ethers';
import { ethers } from 'ethers';
import { LitContracts } from '@lit-protocol/contracts-sdk';
import { LitNodeClient } from '@lit-protocol/lit-node-client';
export var getLitContractClient = function (pkpPublicKey, sessionSig) { return __awaiter(void 0, void 0, Promise, function () {
    var key, litProvider, litNodeClient;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!global._litContract) {
                    global._litContract = {};
                }
                key = "".concat(pkpPublicKey, "-").concat(sessionSig[Object.keys(sessionSig)[0]]['sig']);
                if (!!global._litContract[key]) return [3 /*break*/, 3];
                litProvider = new ethers.providers.JsonRpcProvider(process.env.NEXT_PUBLIC_LIT_RPC);
                litNodeClient = new LitNodeClient({
                    litNetwork: process.env.NEXT_PUBLIC_LIT_NETWORK,
                    debug: false,
                    rpcUrl: process.env.NEXT_PUBLIC_LIT_RPC,
                });
                return [4 /*yield*/, litNodeClient.connect()];
            case 1:
                _a.sent();
                global._litContract[key] = new LitContracts({
                    provider: litProvider,
                    network: process.env.NEXT_PUBLIC_LIT_NETWORK,
                    rpc: process.env.NEXT_PUBLIC_LIT_RPC,
                    signer: new PKPEthersWallet({
                        pkpPubKey: pkpPublicKey,
                        controllerSessionSigs: sessionSig,
                        rpc: process.env.NEXT_PUBLIC_LIT_RPC,
                        provider: litProvider,
                        litNodeClient: litNodeClient,
                    }),
                });
                return [4 /*yield*/, global._litContract[key].connect()];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                if (!!global._litContract[key].connected) return [3 /*break*/, 5];
                return [4 /*yield*/, global._litContract[key].connect()];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/, global._litContract[key]];
        }
    });
}); };
